@let roomInfos = room();
<div class="header-container">
  <h1 class="header">Teilnehmende des Chats</h1>
  <h2 class="sub-header">Bitte wählen Sie Chatteilnehmende aus, die Sie einladen möchten.</h2>
</div>

<h1 class="chat-name">
  Chat:
  <div class="clamp-text">
    {{ roomInfos ? roomInfos.name : roomName() }}
  </div>
</h1>

<mat-chip-set class="chip-set">
  <app-chip
    #chipHealthcareService
    (click)="selectChip(chipHealthcareService, 'HealthcareService')"
    [isHighlighted]="selectedDirectory === 'HealthcareService' && !this.isVerzeichnisSelected"
    (keydown)="$event.stopPropagation()"
    title="Organisationen">
  </app-chip>
  <app-chip
    #chipPractitionerRole
    (click)="selectChip(chipPractitionerRole, 'PractitionerRole')"
    [isHighlighted]="selectedDirectory === 'PractitionerRole' && !this.isVerzeichnisSelected"
    (keydown)="$event.stopPropagation()"
    title="Personen">
  </app-chip>
  <app-chip
    #chipEndpointDirectory
    (click)="selectChip(chipEndpointDirectory, 'EndpointDirectory')"
    (keydown)="$event.stopPropagation()"
    [isHighlighted]="selectedDirectory === 'EndpointDirectory' && !this.isVerzeichnisSelected"
    title="Endpunkt"></app-chip>
  <app-chip
    #dirVerzeichnis
    (click)="selectChip(dirVerzeichnis)"
    [isHighlighted]="this.isVerzeichnisSelected"
    (keydown)="$event.stopPropagation()"
    title="Matrix-Id"
    [dataTestId]="testIds.verzeichnisChip">
  </app-chip>
</mat-chip-set>
@if (!this.isVerzeichnisSelected) {
  <app-searchbar
    #searchbar
    (searchClicked)="onVzdSearch($event)"
    [controlName]="'query'"
    [dataTestId]="testIds.vzdFieldSearchInput"
    [formDataTestId]="'vzd_field_search'"
    [placeholder]="'Im VZD suchen'"
    aria-label="Im VZD suchen"
    class="searchbar"
    [attr.data-testid]="testIds.vzdSearchbar">
  </app-searchbar>
}

@if (showSpinner) {
  <div class="spinner-backdrop">
    <mat-spinner mode="indeterminate" diameter="24"></mat-spinner>
  </div>
}

@if (searchPerformed && !showSpinner && vzdResults.length === 0) {
  <div class="no-results-message" [attr.data-testid]="testIds.noResultsMessage">
    Leider gibt es zu dieser Suchanfrage kein entsprechendes Suchergebnis. Bitte versuchen Sie es mit einem anderen
    Namen.
  </div>
}

@if (vzdResults.length > 0) {
  <div class="dialog-header">
    @if (isVerzeichnisSelected) {
      <h1 class="header">Homerserver Ergebnisse</h1>
    } @else {
      <h1 class="header">VZD Ergebnisse</h1>
    }
    <h2 class="sub-header">Wählen Sie eine Matrix-ID oder einen Service aus, um diese einzuladen.</h2>
  </div>
  <div class="vzd-results dialog-content" [attr.data-testid]="testIds.vzdTable">
    <app-generic-table
      [dataSource]="vzdResults"
      [columnsToDisplay]="vzdDisplayedColumns"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [totalItems]="totalItems"
      (pageChange)="onVzdPageChange($event)"
      (rowClick)="onSelectVzdRowEvent($event)">
    </app-generic-table>
  </div>
}

@if (this.isVerzeichnisSelected) {
  <app-searchbar
    (searchClicked)="onVerzeichnisSearch()"
    (keyup.enter)="!inviteForm.get('mxid')?.errors?.['pattern'] ? openInfoDialog() : ''"
    [controlName]="'mxid'"
    [dataTestId]="testIds.fieldSearchInput"
    [formDataTestId]="'field_search'"
    [groupOfForm]="inviteForm"
    [placeholder]="'Bitte Matrix-ID eingeben'"
    class="searchbar"
    [attr.data-testid]="testIds.inviteLowerSearchbar">
    @if (inviteForm.get('mxid')?.errors && inviteForm.get('mxid')?.dirty) {
      <div class="error-message" [attr.data-testid]="testIds.errorMessage">
        @if (inviteForm.get('mxid')?.errors?.['required']) {
          Bitte geben Sie eine Matrix-Id an
        }
        @if (inviteForm.get('mxid')?.errors?.['pattern']) {
          Matrix-Id entspricht nicht dem gültigen Format: "&#64;[Benutzer-Id]:[Server-Adresse]"
        }
      </div>
    }
  </app-searchbar>
}

<div class="button-container">
  @if (isCreateRoomDialog()) {
    <app-button (clicked)="onBackBtnClicked()" [dataTestId]="testIds.buttonBack" text="Zurück" />
  }
  <app-button (clicked)="resetForm()" [dataTestId]="testIds.buttonCancel" text="Abbrechen" />
  <app-button
    (clicked)="openInfoDialog()"
    [dataTestId]="testIds.buttonInvite"
    [isDisabled]="isCreateRoomDialog() ? false : !inviteForm.valid"
    [isPrimary]="true"
    [text]="isCreateRoomDialog() ? 'Chat öffnen' : 'Einladen'" />
</div>
